import PropTypes from 'prop-types';
import React from 'react';

class ShippingLabelStaticAddress extends React.Component {
  displayExtendedAddress() {
    if (this.props.extendedAddress === '') { return null; }

    return (
      <div>{this.props.extendedAddress}</div>
    );
  }

  displayCityState() {
    return (
      <div>
        {this.props.locality}, {this.props.region} {this.props.postalCode}
      </div>
    );
  }

  displayProperty(addressProperty) {
    if (!addressProperty) { return null; }

    return (
      <div>{addressProperty}</div>
    );
  }

  render() {
    return (
      <div>
        {this.displayProperty(this.props.name)}
        {this.displayProperty(this.props.streetAddress)}
        {this.displayProperty(this.props.extendedAddress)}
        {this.displayCityState()}
        {this.displayProperty(this.props.countryCode)}
        {this.displayProperty(this.props.phone)}
      </div>
    );
  }
}

ShippingLabelStaticAddress.propTypes = {
  name: PropTypes.string,
  streetAddress: PropTypes.string,
  extendedAddress: PropTypes.string,
  locality: PropTypes.string,
  region: PropTypes.string,
  postalCode: PropTypes.string,
  countryCode: PropTypes.string,
  phone: PropTypes.string,
};

export default ShippingLabelStaticAddress;
